import { ref, nextTick, computed, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-44a5fe81"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  key: 0,
  class: "back-box",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 谷歌商品配置 ")], -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = {
  key: 0,
  class: "card planCard"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 基础方案 ")], -1));
const _hoisted_9 = {
  class: "card priceCard"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 价格设置 ")], -1));
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1,
  class: "price-input-flex"
};
const _hoisted_13 = {
  class: "price-input-flex-item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "currency-tip"
}, " *该产品默认币种非USD，可在左侧输入框内填写美元金额，系统会自动换算成默认币种配置 ", -1));
const _hoisted_15 = {
  class: "taxRateBox"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rate-tips"
}, "开启后新加坡本地价格将自动上调9%，以规避新加坡地区GST税费", -1));
const _hoisted_17 = {
  key: 1,
  class: "card",
  style: {
    "padding": "0"
  }
};
const _hoisted_18 = {
  class: "submitBlock"
};
const _hoisted_19 = {
  class: "selectBox"
};
import useGetSelect from '@/hooks/useGetSelect';
import MultiComponents from './components/MultiComponents.vue';
import PriceBlock from './components/PriceBlock.vue';
import BasicPlanNotAuto from './components/BasicPlanNotAuto.vue';
import BasicPlanAuto from './components/BasicPlanAuto.vue';
import DiscountPlan from './components/DiscountPlan.vue';
import useDetailHooks from './hooks/useDetailHooks';
import RecordDrawer from './components/RecordDrawer.vue';
import { cloneDeep } from 'lodash';
import { queryPkgInfo, queryGoods, addGoods, updGoods, getLastLangInfo, queryPriceList } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { awaitWrap, getNode, OK, reportEvent } from '@/common';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'goodsSettingDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      getCountryCoinOptions
    } = useGetSelect('google');
    const {
      prodTypeOptions,
      detailFormInit,
      describtionKey,
      purchaseType,
      rentalOptions,
      verifyNumber,
      validatePidAuto,
      validateGooglePidAuto
    } = useDetailHooks();
    const recordVisible = ref(false);
    const disabled = ref(false); // 禁用改动
    let timout = null;
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null,
      type: ''
    });
    const saveNext = ref(false); // 是否连续创建，保存后留在本页，清空配置信息，保留其他例如价格信息
    const typeDisabled = ref(true);
    const multiComponentRef = ref(null); // 组件ref
    const priceBlockRef = ref(null);
    const myFormRef = ref(null);
    const discountPlanRef = ref(null);
    const loading = ref(false);
    const priceLoading = ref(false);
    const lastLangInfo = ref([]);
    const showLastLangInfo = ref(false); // 历史语言信息显示隐藏
    const saveLoading = ref(false); // 保存按钮可用性
    const originUsdPrice = ref(''); // 美元价格
    const taxRateSwitch = ref(true); // 新加坡税率开关
    const settingForm = ref(cloneDeep(detailFormInit));
    const cCountry = ref('');
    const originPriceList = ref([]); // 最初的价格历史合集
    const isManualProdId = ref(false); // 内购ID是否为自动生成，false表示手动修改过
    const prodIdBeforeFocus = ref(''); // 内购ID失焦前的值
    const getDetail = async () => {
      const res = await queryGoods({
        id: queryParams.value.id
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _settingForm$value, _priceBlockRef$value;
        const prodPriceCurrency = (_settingForm$value = settingForm.value) === null || _settingForm$value === void 0 ? void 0 : _settingForm$value.prodPriceCurrency;
        settingForm.value = {
          ...settingForm.value,
          ...res.data,
          prodPriceCurrency
        };
        // 编辑、查看时回显税率开关状态
        if (['edit', 'watch'].includes(queryParams.value.type) && showRateSwitch.value) {
          var _res$data$bizInfo$sgt, _res$data$bizInfo;
          taxRateSwitch.value = (_res$data$bizInfo$sgt = (_res$data$bizInfo = res.data.bizInfo) === null || _res$data$bizInfo === void 0 || (_res$data$bizInfo = _res$data$bizInfo.sgtPriceAdjustment) === null || _res$data$bizInfo === void 0 ? void 0 : _res$data$bizInfo.enabled) !== null && _res$data$bizInfo$sgt !== void 0 ? _res$data$bizInfo$sgt : false;
        }
        // 保存一份最初的价格合集，用来处理调整区域列表
        originPriceList.value = res.data.productNativePrice;
        (_priceBlockRef$value = priceBlockRef.value) === null || _priceBlockRef$value === void 0 || _priceBlockRef$value.init(res.data);
        if (prodPriceCurrency !== 'USD') {
          var _res$data;
          await getUSDPrice();
          // 初始化默认币种为非美元时，美元价格需要从queryGoods接口获取不能从价格回显位置获取
          originUsdPrice.value = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.productNativePrice) === null || _res$data === void 0 || (_res$data = _res$data.filter(item => {
            return item.regionName === '美国';
          })) === null || _res$data === void 0 || (_res$data = _res$data[0]) === null || _res$data === void 0 ? void 0 : _res$data.prodPrice;
        }
        if (['10', '20'].includes(settingForm.value.prodType)) {
          var _res$data$bizInfo$goo, _res$data$bizInfo2, _res$data$bizInfo$goo2, _res$data$bizInfo3;
          // 给购买类型和租期赋值
          const purchaseType = (_res$data$bizInfo$goo = (_res$data$bizInfo2 = res.data.bizInfo) === null || _res$data$bizInfo2 === void 0 || (_res$data$bizInfo2 = _res$data$bizInfo2.googleRentalConfig) === null || _res$data$bizInfo2 === void 0 ? void 0 : _res$data$bizInfo2.purchaseType) !== null && _res$data$bizInfo$goo !== void 0 ? _res$data$bizInfo$goo : 'buy';
          const rentalPeriod = (_res$data$bizInfo$goo2 = (_res$data$bizInfo3 = res.data.bizInfo) === null || _res$data$bizInfo3 === void 0 || (_res$data$bizInfo3 = _res$data$bizInfo3.googleRentalConfig) === null || _res$data$bizInfo3 === void 0 ? void 0 : _res$data$bizInfo3.rentalPeriod) !== null && _res$data$bizInfo$goo2 !== void 0 ? _res$data$bizInfo$goo2 : 'PT24H';
          settingForm.value.purchaseType = purchaseType;
          settingForm.value.rentalPeriod = rentalPeriod;
        }
      }
    }; // 查询详情信息
    // 获取价格回显
    const getUSDPrice = async () => {
      try {
        let params = {
          pkg: settingForm.value.pkg,
          prodChnl: queryParams.value.prodChnl,
          prodPrice: settingForm.value.prodPrice,
          prodPriceCurrency: settingForm.value.prodPriceCurrency,
          prodType: settingForm.value.prodType,
          dbtId: queryParams.value.dbtId
        };
        // 渠道谷歌+默认币种是SGD则增加参数
        if (showRateSwitch.value) {
          params = Object.assign({}, params, {
            applySgtAdjustment: taxRateSwitch.value
          });
        }
        const res = await queryPriceList(params);
        if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
          var _res$data2;
          originUsdPrice.value = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.productNativePrice) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.filter(item => {
            return item.regionName === '美国';
          })) === null || _res$data2 === void 0 || (_res$data2 = _res$data2[0]) === null || _res$data2 === void 0 ? void 0 : _res$data2.prodPrice;
        }
      } catch (error) {
        message.error('价格处理失败，请稍后重试');
        return false;
      } finally {
        priceLoading.value = false;
      }
    };
    const getPkg = async () => {
      loading.value = true;
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      typeDisabled.value = false;
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _res$data3;
        settingForm.value.pkg = res.data.pkg;
        settingForm.value.prodId = res.data.pkg;
        settingForm.value.defaultLang = res.data.defaultLang;
        settingForm.value.prodPriceCurrency = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.currency;
        cCountry.value = res.data.country;
      }
      loading.value = false;
    }; //查询包名等信息
    const validateAndHandlePrice = async (price, currency) => {
      try {
        var _priceBlockRef$value2;
        if (!price) {
          message.warning(`请先填写${currency === 'USD' ? '美元' : '默认'}价格`);
          return false;
        }
        if (parseFloat(price) <= 0) {
          return false;
        }
        const flag = await verifyNumber({
          prodChnl: queryParams.value.prodChnl,
          prodPrice: parseFloat(price).toFixed(2),
          prodPriceCurrency: currency,
          prodType: settingForm.value.prodType
        });
        if (!flag) {
          return false;
        }
        priceLoading.value = true;
        let useParams = {
          pkg: settingForm.value.pkg,
          prodChnl: queryParams.value.prodChnl,
          prodPrice: parseFloat(price).toFixed(2),
          prodPriceCurrency: currency,
          prodType: settingForm.value.prodType,
          dbtId: queryParams.value.dbtId
        };
        if (showRateSwitch.value) {
          useParams = Object.assign({}, useParams, {
            applySgtAdjustment: taxRateSwitch.value
          });
        }
        await ((_priceBlockRef$value2 = priceBlockRef.value) === null || _priceBlockRef$value2 === void 0 ? void 0 : _priceBlockRef$value2.queryData(useParams));
        priceLoading.value = false;
        callbackPrice();
        return true;
      } catch (error) {
        console.error('价格处理失败:', error);
        message.error('价格处理失败，请稍后重试');
        return false;
      } finally {
        priceLoading.value = false;
      }
    };
    const getChangePrice = async () => {
      if (timout) {
        clearTimeout(timout);
      }
      const success = await validateAndHandlePrice(settingForm.value.prodPrice, settingForm.value.prodPriceCurrency);
      if (!success) {
        settingForm.value.prodPrice = '';
      }
    };
    const getPriceByUsd = async () => {
      if (timout) {
        clearTimeout(timout);
      }
      const success = await validateAndHandlePrice(originUsdPrice.value, 'USD');
      if (!success) {
        originUsdPrice.value = '';
      }
    };
    const changeProdPrice = () => {
      // 节流
      if (timout) {
        clearTimeout(timout);
      }
      timout = setTimeout(async () => {
        getChangePrice();
      }, 800);
    }; // 变更默认价格需要重新请求价目表
    const prodPriceCurrencyObj = {
      USD: '美国',
      HKD: '香港',
      SGD: '新加坡'
    };
    const callbackPrice = () => {
      var _priceBlockRef$value3;
      // 渠道是google且默认币种是SGD时，使用originProdPrice
      const priceField = showRateSwitch.value ? 'originProdPrice' : 'prodPrice';
      settingForm.value.prodPrice = (_priceBlockRef$value3 = priceBlockRef.value) === null || _priceBlockRef$value3 === void 0 || (_priceBlockRef$value3 = _priceBlockRef$value3.originData.filter(item => {
        return item.regionName === prodPriceCurrencyObj[settingForm.value.prodPriceCurrency];
      })) === null || _priceBlockRef$value3 === void 0 || (_priceBlockRef$value3 = _priceBlockRef$value3[0]) === null || _priceBlockRef$value3 === void 0 ? void 0 : _priceBlockRef$value3[priceField];
      if (settingForm.value.prodPriceCurrency !== 'USD') {
        var _priceBlockRef$value4;
        originUsdPrice.value = (_priceBlockRef$value4 = priceBlockRef.value) === null || _priceBlockRef$value4 === void 0 || (_priceBlockRef$value4 = _priceBlockRef$value4.originData.filter(item => {
          return item.regionName === '美国';
        })) === null || _priceBlockRef$value4 === void 0 || (_priceBlockRef$value4 = _priceBlockRef$value4[0]) === null || _priceBlockRef$value4 === void 0 ? void 0 : _priceBlockRef$value4.prodPrice;
      }
    }; // 价格列表回调
    const cancel = () => {
      window.history.go(-1);
    }; // 取消逻辑
    const setProdId = e => {
      e = e.trim();
      if (queryParams.value.id) return; // 编辑时不允许修改内购ID
      if (isManualProdId.value) return; // 用户主动修改过，后面就不自动根据商品信息拼接
      let pkgStr = settingForm.value.pkg; // 拼接前缀
      let lengthLimit = 140; // 最大字符数
      if (['31', '32'].includes(settingForm.value.prodType)) {
        // 订阅非订阅类需要调整字符数和拼接pkg的内容
        pkgStr = settingForm.value.pkg.split('.').map(item => item[0]).join('.');
        lengthLimit = 40;
      }
      if (!e.length) {
        // 值为空的时候赋值为包名
        settingForm.value.prodId = pkgStr;
        return;
      }
      try {
        var _getStr$match;
        let getStr = e.toLowerCase().replace(/\s*/g, '');
        getStr = ((_getStr$match = getStr.match(/[a-z0-9.]/g)) === null || _getStr$match === void 0 ? void 0 : _getStr$match.join('')) || '';
        const countStr = lengthLimit - pkgStr.length - 1;
        settingForm.value.prodId = pkgStr + '.' + getStr.slice(0, countStr);
      } catch (error) {}
      myFormRef.value.validate();
    }; // 根据商品名/订阅名，内购ID自动拼接
    // 内购ID获取焦点时，记录当前值
    const handleProdIdFocus = () => {
      prodIdBeforeFocus.value = settingForm.value.prodId;
    };
    // 内购ID失焦时，判断值是否改变
    const handleProdIdBlur = () => {
      if (prodIdBeforeFocus.value !== settingForm.value.prodId) {
        // 值发生改变，说明用户手动修改过，将flag置为true
        isManualProdId.value = true;
      }
    };
    const changeProdType = () => {
      nextTick(() => {
        var _settingForm$value2;
        setProdId((_settingForm$value2 = settingForm.value) === null || _settingForm$value2 === void 0 || (_settingForm$value2 = _settingForm$value2.productNativeInfo[0]) === null || _settingForm$value2 === void 0 ? void 0 : _settingForm$value2.prodName);
      });
      // 如果是非消耗型-购买状态设置为购买
      if (settingForm.value.prodType == '10') {
        settingForm.value.purchaseType = 'buy';
      }
    }; // 变更商品类型需要注意内购ID重新组合
    const checker = () => {
      var _priceBlockRef$value5;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        const item = settingForm.value.productNativeInfo[i];
        if (!item.lang || !item.prodDescription || !item.prodName) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
        if (settingForm.value.prodType === '31' || settingForm.value.prodType === '32') {
          var _item$prodName, _item$prodDescription, _item$prodName2, _item$prodDescription2;
          if (((_item$prodName = item.prodName) === null || _item$prodName === void 0 ? void 0 : _item$prodName.length) > 55) {
            item.error = '商品名称不能超过55个字符';
          }
          if (((_item$prodDescription = item.prodDescription) === null || _item$prodDescription === void 0 ? void 0 : _item$prodDescription.length) > 40) {
            item.error = '商品描述不能超过40个字符';
          }
          if (((_item$prodName2 = item.prodName) === null || _item$prodName2 === void 0 ? void 0 : _item$prodName2.length) <= 55 && ((_item$prodDescription2 = item.prodDescription) === null || _item$prodDescription2 === void 0 ? void 0 : _item$prodDescription2.length) <= 40) {
            item.error = '';
          }
        } else {
          var _item$prodName3, _item$prodDescription3, _item$prodName4, _item$prodDescription4;
          if (((_item$prodName3 = item.prodName) === null || _item$prodName3 === void 0 ? void 0 : _item$prodName3.length) > 55) {
            item.error = '商品名称不能超过55个字符';
          }
          if (((_item$prodDescription3 = item.prodDescription) === null || _item$prodDescription3 === void 0 ? void 0 : _item$prodDescription3.length) > 200) {
            item.error = '商品描述不能超过200个字符';
          }
          if (((_item$prodName4 = item.prodName) === null || _item$prodName4 === void 0 ? void 0 : _item$prodName4.length) <= 55 && ((_item$prodDescription4 = item.prodDescription) === null || _item$prodDescription4 === void 0 ? void 0 : _item$prodDescription4.length) <= 200) {
            item.error = '';
          }
        }
      } // 商品信息校验
      if (settingForm.value.productNativeInfo.filter(item => item.error).length) {
        return false;
      }
      const getPriceArr = (_priceBlockRef$value5 = priceBlockRef.value) === null || _priceBlockRef$value5 === void 0 ? void 0 : _priceBlockRef$value5.originData;
      if (!getPriceArr.length) {
        message.error('价格信息表内容不能为空');
        return false;
      } else {
        for (let i = 0; i < getPriceArr.length; i++) {
          const item = getPriceArr[i];
          if (!item.prodPrice) {
            message.error('价格信息内容请填写完整');
            return false;
          }
        } // 价格信息校验
      }
      return true;
    }; // 自定义部分校验
    const handleSaveParams = () => {
      if (settingForm.value.prodType === '31') {
        var _settingForm$value3, _settingForm$value4, _settingForm$value5;
        delete settingForm.value.prodGracePlan;
        settingForm.value.prodBasePlan = {
          planDuration: (_settingForm$value3 = settingForm.value) === null || _settingForm$value3 === void 0 || (_settingForm$value3 = _settingForm$value3.prodBasePlan) === null || _settingForm$value3 === void 0 ? void 0 : _settingForm$value3.planDuration,
          timeExtension: (_settingForm$value4 = settingForm.value) === null || _settingForm$value4 === void 0 || (_settingForm$value4 = _settingForm$value4.prodBasePlan) === null || _settingForm$value4 === void 0 ? void 0 : _settingForm$value4.timeExtension,
          id: (_settingForm$value5 = settingForm.value) === null || _settingForm$value5 === void 0 || (_settingForm$value5 = _settingForm$value5.prodBasePlan) === null || _settingForm$value5 === void 0 ? void 0 : _settingForm$value5.id
        };
      } else if (settingForm.value.prodType === '32') {
        var _settingForm$value6, _settingForm$value7;
        (_settingForm$value6 = settingForm.value) === null || _settingForm$value6 === void 0 || (_settingForm$value6 = _settingForm$value6.prodBasePlan) === null || _settingForm$value6 === void 0 || delete _settingForm$value6.planDuration;
        (_settingForm$value7 = settingForm.value) === null || _settingForm$value7 === void 0 || (_settingForm$value7 = _settingForm$value7.prodBasePlan) === null || _settingForm$value7 === void 0 || delete _settingForm$value7.timeExtension;
      } else {
        delete settingForm.value.prodBasePlan;
        delete settingForm.value.prodGracePlan;
      }
    }; // 提交前根据商品类型处理多余结构
    const save = async () => {
      myFormRef.value.validate().then(async valid => {
        try {
          if (valid) {
            var _priceBlockRef$value6;
            if (!checker()) return;
            const fn = queryParams.value.id ? updGoods : addGoods;
            handleSaveParams();
            let params = {
              ...settingForm.value,
              prodChnl: queryParams.value.prodChnl,
              dbtId: queryParams.value.dbtId,
              productNativePrice: (_priceBlockRef$value6 = priceBlockRef.value) === null || _priceBlockRef$value6 === void 0 ? void 0 : _priceBlockRef$value6.originData
            };
            // 渠道谷歌+默认币种是SGD则增加参数
            if (showRateSwitch.value) {
              params = Object.assign({}, params, {
                bizInfo: {
                  sgtPriceAdjustment: {
                    enabled: taxRateSwitch.value
                  }
                }
              });
            }
            if (settingForm.value.prodType === '32' && discountPlanRef.value.checkOut()) {
              var _discountPlanRef$valu, _discountPlanRef$valu2, _settingForm$value8;
              params = {
                ...params,
                prodGracePlan: (_discountPlanRef$valu = discountPlanRef.value) !== null && _discountPlanRef$valu !== void 0 && _discountPlanRef$valu.handleData() ? {
                  ...((_discountPlanRef$valu2 = discountPlanRef.value) === null || _discountPlanRef$valu2 === void 0 ? void 0 : _discountPlanRef$valu2.handleData()),
                  id: (_settingForm$value8 = settingForm.value) === null || _settingForm$value8 === void 0 || (_settingForm$value8 = _settingForm$value8.prodGracePlan) === null || _settingForm$value8 === void 0 ? void 0 : _settingForm$value8.id
                } : null
              };
            } else if (settingForm.value.prodType === '32' && !discountPlanRef.value.checkOut()) {
              return params.prodGracePlan = null;
            }
            if (params.pkg === params.prodId) {
              return message.error('内购ID不可完全等于包名，请手动补齐内购ID后半部分');
            }
            // 消耗性和非消耗性需要增加入参bizInfo
            if (['10', '20'].includes(settingForm.value.prodType)) {
              // 谷歌新增购买类型参数
              const googleRentalConfig = {
                purchaseType: settingForm.value.purchaseType,
                rentalPeriod: settingForm.value.rentalPeriod // 仅rent时需要
              };
              // 非消耗型去掉租赁值
              if (settingForm.value.prodType === '10') {
                delete googleRentalConfig.rentalPeriod;
              }
              params.bizInfo = Object.assign(params.bizInfo || {}, {
                googleRentalConfig
              });
            }
            saveLoading.value = true;
            const res = await fn(params);
            saveLoading.value = false;
            if (res.code === '0') {
              message.success('商品保存成功！');
              if (!saveNext.value) {
                router.push({
                  name: 'goodsSetting'
                });
              } else {
                var _priceBlockRef$value7;
                settingForm.value = {
                  ...cloneDeep(detailFormInit),
                  prodPriceCurrency: settingForm.value.prodPriceCurrency,
                  prodType: settingForm.value.prodType,
                  pkg: settingForm.value.pkg,
                  productNativeInfo: settingForm.value.productNativeInfo.map(item => {
                    return {
                      ...item,
                      prodDescription: '',
                      prodName: ''
                    };
                  })
                };
                (_priceBlockRef$value7 = priceBlockRef.value) === null || _priceBlockRef$value7 === void 0 || _priceBlockRef$value7.reset();
                changeProdType();
              }
              reportEvent({
                eventName: 'element_use',
                properties: {
                  ui_name: '谷歌商品配置',
                  element_name: '保存'
                }
              });
            } else {}
          }
        } catch (error) {}
      });
    }; // 保存逻辑
    const queryLastLangInfo = async () => {
      const [err, res] = await awaitWrap(getLastLangInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      }));
      if (err) return void 0;
      if (res && res.code === OK) {
        var _res$data4, _res$data5;
        if (((_res$data4 = res.data) === null || _res$data4 === void 0 || (_res$data4 = _res$data4.lastLangInfos) === null || _res$data4 === void 0 ? void 0 : _res$data4.length) <= 1) return showLastLangInfo.value = false;
        showLastLangInfo.value = true;
        lastLangInfo.value = (_res$data5 = res.data) === null || _res$data5 === void 0 || (_res$data5 = _res$data5.lastLangInfos) === null || _res$data5 === void 0 ? void 0 : _res$data5.map(item => {
          return {
            ...item,
            prodDescription: '',
            prodName: ''
          };
        });
      } else {
        message.error(res.msg);
      }
    }; // 查询历史语言信息
    const changeLastLangInfo = () => {
      // 找到默认语言对应的项
      const defaultLangItem = settingForm.value.productNativeInfo.find(item => item.lang === settingForm.value.defaultLang);
      // 保存默认语言的 prodDescription 和 prodName（如果有填写）
      const savedProdDescription = (defaultLangItem === null || defaultLangItem === void 0 ? void 0 : defaultLangItem.prodDescription) || '';
      const savedProdName = (defaultLangItem === null || defaultLangItem === void 0 ? void 0 : defaultLangItem.prodName) || '';
      settingForm.value.productNativeInfo = cloneDeep(lastLangInfo.value);
      // 如果默认语言有填写内容，则恢复到新数组中对应的语言项
      if ((savedProdDescription || savedProdName) && settingForm.value.defaultLang) {
        const targetIndex = settingForm.value.productNativeInfo.findIndex(item => item.lang === settingForm.value.defaultLang);
        if (targetIndex !== -1) {
          settingForm.value.productNativeInfo[targetIndex].prodDescription = savedProdDescription;
          settingForm.value.productNativeInfo[targetIndex].prodName = savedProdName;
        }
      }
    }; // 修改历史语言信息
    const showRateSwitch = computed(() => {
      return cCountry.value == 'SG' && queryParams.value.prodChnl == 'google';
    }); // 渠道谷歌+默认币种是SGD则暂时税率开关
    const rateSwitchStatus = computed(() => {
      return queryParams.value.type === 'watch';
    }); // 详情时无法编辑税率开关
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      if (route.query.type === 'watch') {
        disabled.value = true;
      }
      await getCountryCoinOptions();
      await getPkg();
      await queryLastLangInfo();
      if (queryParams.value.id) {
        getDetail();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_skeleton_button = _resolveComponent("a-skeleton-button");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myFormRef",
        ref: myFormRef,
        model: settingForm.value,
        "label-col": {
          style: 'width: 90px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [queryParams.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = () => {
            _unref(router).back();
          })
        }, {
          default: _withCtx(() => [_createTextVNode(" 返回 ")]),
          _: 1
        }), _createElementVNode("div", {
          class: "record-text",
          onClick: _cache[1] || (_cache[1] = $event => recordVisible.value = true)
        }, "变更记录")])) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_form_item, {
          label: "商品类型",
          name: "prodType",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.prodType,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.prodType = $event),
            options: _unref(prodTypeOptions),
            disabled: typeDisabled.value || disabled.value || !!queryParams.value.id,
            onChange: changeProdType,
            getPopupContainer: _unref(getNode)
          }, {
            option: _withCtx(({
              label,
              describtion
            }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
            _: 1
          }, 8, ["value", "options", "disabled", "getPopupContainer"])]),
          _: 1
        }), ['20', '10'].includes(settingForm.value.prodType) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 1,
          label: "购买类型",
          name: "purchaseType",
          rules: [{
            required: true,
            message: '请选择购买类型',
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.purchaseType,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.purchaseType = $event),
            options: _unref(purchaseType),
            getPopupContainer: _unref(getNode),
            disabled: settingForm.value.prodType == '10' || ['edit', 'watch'].includes(queryParams.value.type)
          }, null, 8, ["value", "options", "getPopupContainer", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), settingForm.value.purchaseType == 'rent' && settingForm.value.prodType == '20' ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 2,
          label: "租期",
          name: "rentalPeriod",
          rules: [{
            required: true,
            message: '请选择租期',
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.rentalPeriod,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.rentalPeriod = $event),
            disabled: disabled.value,
            options: _unref(rentalOptions),
            getPopupContainer: _unref(getNode)
          }, null, 8, ["value", "disabled", "options", "getPopupContainer"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          label: "商品信息",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => {
            var _unref$settingForm$va, _unref$settingForm$va2;
            return [loading.value ? (_openBlock(), _createBlock(_component_a_skeleton_button, {
              key: 0,
              active: "",
              block: "",
              style: {
                "width": "740px"
              }
            })) : (_openBlock(), _createBlock(MultiComponents, {
              key: 1,
              ref_key: "multiComponentRef",
              ref: multiComponentRef,
              filterItems: settingForm.value.productNativeInfo,
              onSetProdId: setProdId,
              disabled: disabled.value,
              "default-lang": settingForm.value.defaultLang,
              onGetLastLange: changeLastLangInfo,
              showLastLangInfo: showLastLangInfo.value,
              nameRule: ((_unref$settingForm$va = _unref(describtionKey)[settingForm.value.prodType]) === null || _unref$settingForm$va === void 0 ? void 0 : _unref$settingForm$va.nameRule) || _unref(describtionKey)['10'].nameRule,
              desRule: ((_unref$settingForm$va2 = _unref(describtionKey)[settingForm.value.prodType]) === null || _unref$settingForm$va2 === void 0 ? void 0 : _unref$settingForm$va2.desRule) || _unref(describtionKey)['10'].desRule
            }, null, 8, ["filterItems", "disabled", "default-lang", "showLastLangInfo", "nameRule", "desRule"]))];
          }),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "内购ID",
          name: "prodId",
          rules: [{
            required: true,
            trigger: ['change', 'blur'],
            validator: ['31', '32'].includes(settingForm.value.prodType) ? _unref(validatePidAuto) : _unref(validateGooglePidAuto)
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "inputer",
            value: settingForm.value.prodId,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.prodId = $event),
            placeholder: "请输入内购ID",
            disabled: Boolean(queryParams.value.id) || disabled.value,
            onFocus: handleProdIdFocus,
            onBlur: handleProdIdBlur
          }, null, 8, ["value", "disabled"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createElementVNode("span", null, " 内购ID自动生成规则：包名+内购名称，全小写，不超过" + _toDisplayString(!['31', '32'].includes(settingForm.value.prodType) ? 135 : 40) + "字符 ", 1)]),
            default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
              class: "infoIcon ml8"
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules"]), _createVNode(_component_a_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.remark,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => settingForm.value.remark = $event),
            placeholder: "请输入",
            disabled: disabled.value,
            maxLength: 20
          }, null, 8, ["value", "disabled"])]),
          _: 1
        })]), ['31', '32'].includes(settingForm.value.prodType) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, settingForm.value.prodType === '31' ? (_openBlock(), _createBlock(BasicPlanNotAuto, {
          key: 0,
          detail: settingForm.value,
          disabled: disabled.value
        }, null, 8, ["detail", "disabled"])) : _createCommentVNode("", true), settingForm.value.prodType === '32' ? (_openBlock(), _createBlock(BasicPlanAuto, {
          key: 1,
          detail: settingForm.value,
          disabled: disabled.value
        }, null, 8, ["detail", "disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_a_form_item, {
          label: "默认价格",
          required: ""
        }, {
          default: _withCtx(() => [settingForm.value.prodPriceCurrency === 'USD' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_a_input_number, {
            class: "priceInputer",
            value: settingForm.value.prodPrice,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => settingForm.value.prodPrice = $event),
            "addon-after": settingForm.value.prodPriceCurrency,
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value,
            onBlur: getChangePrice
          }, null, 8, ["value", "addon-after", "step", "disabled"])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_a_input_number, {
            class: "little-price",
            value: originUsdPrice.value,
            "onUpdate:value": _cache[8] || (_cache[8] = $event => originUsdPrice.value = $event),
            "addon-after": "USD",
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value,
            onBlur: getPriceByUsd
          }, null, 8, ["value", "step", "disabled"]), _createVNode(_component_SvgIcon, {
            "icon-class": "swap",
            class: "swap-icon"
          }), _createVNode(_component_a_input_number, {
            class: "little-price",
            value: settingForm.value.prodPrice,
            "onUpdate:value": _cache[9] || (_cache[9] = $event => settingForm.value.prodPrice = $event),
            "addon-after": settingForm.value.prodPriceCurrency,
            step: 0.01,
            controls: false,
            precision: 2,
            "string-mode": "",
            disabled: disabled.value,
            onBlur: getChangePrice
          }, null, 8, ["value", "addon-after", "step", "disabled"])]), _hoisted_14]))]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "本地价格",
          rules: [{
            required: true
          }]
        }, {
          default: _withCtx(() => [_createVNode(PriceBlock, {
            "prod-chnl": queryParams.value.prodChnl,
            "prod-price-currency": settingForm.value.prodPriceCurrency,
            "prod-type": settingForm.value.prodType,
            disabled: disabled.value,
            ref_key: "priceBlockRef",
            ref: priceBlockRef,
            onUpdateList: changeProdPrice,
            loading: priceLoading.value,
            taxRateSwitch: taxRateSwitch.value,
            originPriceList: originPriceList.value
          }, null, 8, ["prod-chnl", "prod-price-currency", "prod-type", "disabled", "loading", "taxRateSwitch", "originPriceList"])]),
          _: 1
        }), _unref(showRateSwitch) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          label: "GST调价"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_a_switch, {
            checked: taxRateSwitch.value,
            "onUpdate:checked": _cache[10] || (_cache[10] = $event => taxRateSwitch.value = $event),
            disabled: _unref(rateSwitchStatus) || priceLoading.value,
            onChange: _cache[11] || (_cache[11] = $event => getChangePrice())
          }, null, 8, ["checked", "disabled"]), _hoisted_16])]),
          _: 1
        })) : _createCommentVNode("", true)]), settingForm.value.prodType === '32' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(DiscountPlan, {
          ref_key: "discountPlanRef",
          ref: discountPlanRef,
          detail: settingForm.value,
          priceArr: priceBlockRef.value.originData,
          "read-only": disabled.value
        }, null, 8, ["detail", "priceArr", "read-only"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"]), _withDirectives(_createElementVNode("div", _hoisted_18, [_createVNode(_component_a_button, {
        onClick: cancel
      }, {
        default: _withCtx(() => [_createTextVNode("取 消")]),
        _: 1
      }), _createVNode(_component_a_button, {
        loading: saveLoading.value,
        class: "ml8",
        type: "primary",
        onClick: save,
        disabled: priceLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode(" 保 存 ")]),
        _: 1
      }, 8, ["loading", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_19, [_createVNode(_component_a_checkbox, {
        checked: saveNext.value,
        "onUpdate:checked": _cache[12] || (_cache[12] = $event => saveNext.value = $event)
      }, {
        default: _withCtx(() => [_createTextVNode("连续创建")]),
        _: 1
      }, 8, ["checked"])], 512), [[_vShow, !queryParams.value.id]])], 512), [[_vShow, !disabled.value]]), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = $event => recordVisible.value = $event)
      }, null, 8, ["visible"])]);
    };
  }
});